<template>
  <div class="retail__container container-custom">
    <div class="retail__cart">
      <button @click="handleViewBetSlip" class="focusable">
        <img src="@/assets/images/home/cart.svg" />
        <span class="badge badge-light">{{ badgeNumber}}</span>
      </button>
    </div>
    <TabsCommon
        :tabs="tabsSelection"
    />
    <ModalCommon
        v-if="showModalBetslip"
        @close="showModalBetslip = false"
        @login="handleLogin"
        @process-bet="processBetslipTransat"
        @book-a-bet="handleBookABet"
        :isClassModalCustom="isModalCustomClass"
    >
      <YourBetslip
          @print="handlePrint"
          :isShowPrint="printBet"
          :data-betslip="listDataBetslipsRetail"
          v-bind:commonStake="commonStake"
          v-bind:totalStake="totalStake"
          :loading="loadingProcessBet"
          :loading-boot-a-bet="loadingBootABet"
          :is-disable-process-bet="isDisableProcessBet"
          :is-show-error-expired="isShowErrorExpired"
          :is-show-res-book-a-bet="isShowResBookABet"
          :booking-code-boot-a-bet="bookingCodeBootABet"
          @changeStake="handleChangeStake"
          @removeItemBetslip="handleRemoveItemBetslip"
          @removeAllBetslip="handleRemoveAllBetslips"
          @removeDrawsExpired="removeDrawsExpired"
          @moveToNextDraw="moveToNextDraw"
          @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
  </div>

</template>

<script>
import TabsCommon from '@/components/common/tabs/tabs-common.vue';
import TabMainMarkets from "./TabMainMarkets";
import TabAdditionalMarkets from "./TabAdditionalMarkets";
import ModalCommon from '@/components/common/modal/modal-common.vue';
import YourBetslip from "../ticket/betslip/YourBetslipRetail";
import YourBetslipMixinRetail from "../../mixins/betslip/your-betslip-retail-mixin";
export default {
  mixins: [YourBetslipMixinRetail],
  components: {
    TabsCommon,
    ModalCommon,
    YourBetslip
  },
  data () {
    return {
      tabsSelection: [
        {
          title: 'MAIN MARKETS',
          href: 'main-markets',
          isActive: true,
          component: TabMainMarkets,
          classCustom: 'tab-main-ball-set tab-ball-set-common',
          isActiveCustom: true,
        },
        {
          title: 'ADDITIONAL MARKETS',
          href: 'additional-market',
          isActive: false,
          component: TabAdditionalMarkets,
          classCustom: 'tab-power-ball-set tab-ball-set-common',
          isActiveCustom: true,
        }
      ]
    }
  },
  computed: {
    badgeNumber () {
      return this.$store.state.badgeNumberRetail
    }
  },
  mounted() {
    this.initBadgeNumber();
  },
  created() {
    const parameters = this.$route.query
    if (parameters) {
      this.$store.dispatch('initDataCustomer', parameters)
    }
  },
  methods: {
    initBadgeNumber() {
      let yourBetslipStorage = localStorage.getItem('yourBetslipRetail')
      if(yourBetslipStorage) {
        yourBetslipStorage = JSON.parse(yourBetslipStorage)
        this.$store.dispatch('changeBadgeNumberRetail', yourBetslipStorage.length);
      }
    },
  }
}
</script>

<style scoped>
.retail__container {
  border: 2px solid #dee2e6;
  max-width: 1050px;
  margin-top: 50px;
  padding: 30px 50px;
}
.retail__cart {
  text-align: right;
  padding: 10px;
}
.retail__cart button{
  background-color: unset;
}
.retail__cart:hover {
  cursor: pointer;
}
.retail__cart img {
  width: 40px;
}
.retail__cart {
  position: relative;
  cursor: pointer;
}
.badge {
  position: absolute;
  top: 10px;
  font-size: 12px;
  font-weight: 100;
  right: 7px;
  border-radius: 50%;
  background-color: #0c9e0c;
  color: #fff;
  min-width: 17px;
}
@media (max-width: 768px) {
  .retail__container {
    margin-top: 20px;
    padding: 10px 20px;
  }
}
</style>
